export default __webpack_public_path__ + "c6a77953148653cdcd12079e924f69ea.png";